import styled from 'styled-components';
import { Box } from '../Box/Box.js';
import { Flex } from '../Flex/Flex.js';

const Wrapper = styled(Box) `
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const StyledThumbnail = styled(Flex) `
  align-items: center;
  background: url(${({ src }) => src}) no-repeat center center;
  background-position: center;
  background-size: cover;
  height: 100%;
  justify-content: center;
  width: 100%;
`;
const StyledPlay = styled.div `
  opacity: 0.83;
  &:hover {
    opacity: 1;
  }
`;
const StyledVideo = styled.iframe `
  border: none;
  height: 584px;
  width: 100%;
`;

export { StyledPlay, StyledThumbnail, StyledVideo, Wrapper };
